import { useMemo, useState } from "react";
import { CurrencySelector } from "@/components/portal/CurrencySelector";
import { useCurrency } from "@/hooks/use-currency";
import { Button } from "@/components/ui/button";

export function CurrencyDock() {
  const [expanded, setExpanded] = useState(false);
  const { currency } = useCurrency();

  const currencySymbol = useMemo(() => {
    try {
      const parts = new Intl.NumberFormat("en", {
        style: "currency",
        currency,
        maximumFractionDigits: 0,
      }).formatToParts(0);
      return parts.find((part) => part.type === "currency")?.value ?? "$";
    } catch {
      return "$";
    }
  }, [currency]);

  return (
    <div className="fixed bottom-4 left-4 z-40">
      <div className="rounded-2xl border border-border/60 bg-background/80 px-3 py-2 shadow-sm backdrop-blur-sm">
        <Button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className="h-11 rounded-full px-5 text-sm font-semibold shadow-sm"
          aria-label="Toggle currency selector"
        >
          <span className="font-mono">{currencySymbol}</span>
          <span className="ml-2">{currency}</span>
        </Button>
        {expanded && (
          <div className="ml-3 inline-flex items-center align-middle">
            <CurrencySelector label="Currency" className="gap-2" />
          </div>
        )}
      </div>
    </div>
  );
}
